function initializeMarquee(container) {
  const marqueeText = container.querySelector(".marquee-text");
  if (marqueeText) {
    let textWidth = marqueeText.getBoundingClientRect().width;
    let textHeight = marqueeText.offsetHeight;
    let position = -textWidth;
    let cloned = false; // Moved inside initializeMarquee to reset every call

    container.style.height = textHeight + 'px';

    // Clone the marquee text only once
    if (!cloned) {
      for (let i = 1; i <= 20; i++) {
        const marqueeTextClone = marqueeText.cloneNode(true);
        marqueeTextClone.style.left = (textWidth * i + position) + "px";
        container.appendChild(marqueeTextClone);
      }
      cloned = true; // Set flag to true after cloning
    }

    let intervalId;
    let isPaused = false;

    function marquee() {
      if (isPaused) return;
      position -= 2;
      if (position <= -textWidth) {
        position += textWidth;
      }
      marqueeText.style.left = position + "px";

      for (let i = 1; i <= 20; i++) {
        const marqueeTextClone = container.children[i];
        if (marqueeTextClone) {
          marqueeTextClone.style.left = (position + textWidth * i) + "px";
        }
      }
    }

    intervalId = setInterval(marquee, 50);

    // Pause on hover
    container.addEventListener('mouseenter', function() {
      isPaused = true;
    });

    container.addEventListener('mouseleave', function() {
      isPaused = false;
    });

    let lastWidth = window.innerWidth;
    window.addEventListener('resize', function() {
      if (window.innerWidth === lastWidth) return; // Ignore vertical resizes (like mobile URL bar hiding on scroll)
      lastWidth = window.innerWidth;
      
      textWidth = marqueeText.getBoundingClientRect().width;
      textHeight = marqueeText.offsetHeight;
      position = -textWidth;
      container.style.height = textHeight + 'px';
      marqueeText.style.left = position + "px";
      for (let i = 1; i <= 20; i++) {
        const marqueeTextClone = container.children[i];
        if (marqueeTextClone) {
          marqueeTextClone.style.left = (position + textWidth * i) + "px";
        }
      }
    });
  }
}

window.onload = function() {
  const marqueeContainers = document.querySelectorAll(".marquee-container");
  marqueeContainers.forEach(initializeMarquee);
};

// Ensure marqueeTimeoutId is not redeclared
if (typeof marqueeTimeoutId === 'undefined') {
  var marqueeTimeoutId; // Var for hoisting to global scope
}

document.addEventListener("shopify:section:load", function(event) {
  if (marqueeTimeoutId) {
    clearTimeout(marqueeTimeoutId);
  }
  marqueeTimeoutId = setTimeout(function() {
    if (document.querySelector(`#shopify-section-${event.detail.sectionId} .marquee-container`)) {
      initializeMarquee(document.querySelector(`#shopify-section-${event.detail.sectionId} .marquee-container`));
    }
  }, 300);
});
